import React from "react"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { useNavigationService } from "../../providers/NavigationService"
import { FormTitle } from "../../components/FormTitle"
import { SubmitButton } from "../../components/SubmitButton"

export const ResetPasswordSubmittedScreenContent = () => {
  const { navigate } = useNavigationService()
  const { i18n } = useTranslations()

  return (<Container>
    <FormTitle>{i18n("Account.ResetPasswordRequested:Title")}</FormTitle>

    <TextContainer dangerouslySetInnerHTML={{ __html: i18n("Account.ResetPasswordRequested:Description") }} />

    <SubmitButton label={i18n("Account.ForgottenPassword:BackToLogin")}
                  onClick={() => navigate("/login")}/>
  </Container>)
}

const Container = styled("div")({
  display: "grid", rowGap: "20px"
})

const TextContainer = styled("div")({
  "& p": {
    lineHeight: "21px",
    letterSpacing: 0,
    margin: 0,

    "&:nth-child(1), &:nth-child(2)": {
      fontSize: "14px",
      fontWeight: 400,
    },

    "&:nth-child(3)": {
      fontSize: "12px",
      fontWeight: 300,
      marginTop: "8px"
    },

    "&:nth-child(4)": {
      color: "#0055B0",
      fontSize: "12px",
      fontWeight: 300,
      marginTop: "8px"
    },

    // "&:not(:last-child)": { marginBottom: "20px" }
  },
})
